import { loan_request } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function getRequestStatuses({ url: { service: baseURL }, token }: IAPI) {
  return async function getRequestStatuses(): Promise<loan_request.RequestStatuses> {
    const url = new URL('/loan-quote/request/statuses/all', baseURL);

    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: token ?? '',
      },
    });

    const responseJson = await response.json();

    if (response.ok) return responseJson;

    throw new Error(
      `Error fetching ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.message}`
    );
  };
}
